import { apiClient, type Paginated } from '@/core/api';
import type { TaskPriority, TaskStatus } from './constants';
import type { Task, TaskInput } from './types';

const BASE = '/tasks/';

export interface TaskListParams {
  page?: number;
  /** SearchFilter across title + description. */
  search?: string;
  status?: TaskStatus;
  priority?: TaskPriority;
  assignee?: number;
  content_type?: number;
  object_id?: string | number;
  ordering?: string;
}

export async function listTasks(params: TaskListParams = {}): Promise<Paginated<Task>> {
  const { data } = await apiClient.get<Paginated<Task>>(BASE, { params });
  return data;
}

export async function getTask(id: string | number): Promise<Task> {
  const { data } = await apiClient.get<Task>(`${BASE}${id}/`);
  return data;
}

export async function createTask(input: TaskInput): Promise<Task> {
  const { data } = await apiClient.post<Task>(BASE, input);
  return data;
}

export async function updateTask(id: string | number, input: Partial<TaskInput>): Promise<Task> {
  const { data } = await apiClient.patch<Task>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteTask(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

/** Move a task's status. Allowed for managers or the task's own assignee. */
export async function setTaskStatus(id: string | number, status: TaskStatus): Promise<Task> {
  const { data } = await apiClient.post<Task>(`${BASE}${id}/status/`, { status });
  return data;
}
